import React, { useEffect, useState } from 'react'
import InsightsProvider, { useInsights } from 'contexts/insights'
import { UnitPermissionsProvider, useUnitPermissions } from 'contexts/unit-permissions'
import ChartProvider from 'contexts/chart'
import { size } from 'utilities/object'
import { numbers } from 'utilities/styled'
import SkeletonLoader from 'pages/insights/components/loader'
import { ResponsiveMasonry } from 'react-responsive-masonry'
import Filter from './filter'
import Hero from './hero'
import { Masonry } from './s'
import BarChart from 'components/charts/bar'
import PieChart from 'components/charts/pie'
import TableChart from 'components/charts/table'

const InsightsPageContent = ({ corporation }) => {
    const { insights } = useInsights()
    const { checkAll } = useUnitPermissions()

    const [filter, setFilter] = useState({})
    const [hasFetched, setHasFetched] = useState(false)

    useEffect(() => {
        if(!!size(filter)) {
            setHasFetched(false)
        }
    }, [filter])

    const [, { general: canFetchGroupsFilterless }] = checkAll({
        system: 'insights:manage',
        unit: 'unit:insights:manage'
    })

    return (
        <>
            <Hero
                corporation={corporation}
                showUnitPermissionDisclaimer={!canFetchGroupsFilterless}
                salt="insights" />
            <Filter
                filter={filter}
                setFilter={setFilter}
                corporation={corporation}
                canFetchGroupsFilterless={canFetchGroupsFilterless} />
            {!hasFetched && <SkeletonLoader />}
            <ResponsiveMasonry columnsCountBreakPoints={{
                0: 1,
                [numbers.tablet]: 2
            }}>
                <Masonry gutter="48px">
                    {insights.map(({ id, type }) => {
                        const Chart = typeToChartMap[type]

                        const key = [
                            'insights',
                            'chart',
                            corporation ? 'corporation' : 'standalone',
                            id,
                            type
                        ].join(':')

                        return (
                            <ChartProvider
                                id={id}
                                corporation={corporation}
                                filter={filter}
                                key={key}>
                                {({ hasFetched: hasFetchedChart }) => (
                                    <ChartWrapper
                                        chart={Chart}
                                        hasFetched={hasFetchedChart}
                                        setHasFetched={setHasFetched} />
                                )}
                            </ChartProvider>
                        )
                    })}
                </Masonry>
            </ResponsiveMasonry>
        </>
    )
}

const ChartWrapper = ({ chart: Chart, hasFetched, setHasFetched }) => {
    useEffect(() => {
        if(hasFetched) {
            setHasFetched(true)
        }
    }, [hasFetched])

    return <Chart />
}

export const typeToChartMap = {
    bar: BarChart,
    pie: PieChart,
    table: TableChart
}

export default ({ corporation = false, ...props }) => (
    <UnitPermissionsProvider>
        <InsightsProvider corporation={corporation}>
            <InsightsPageContent
                {...props}
                corporation={corporation} />
        </InsightsProvider>
    </UnitPermissionsProvider>
)